module.exports = __webpack_public_path__ + "img/erweimashixiao.1297d8cb.png";